<template>
  <div
    data-test="inboundLinks"
    :class="{
      'is-blurred': loading,
      'is-invisible': loading && !supportsBlur
    }"
  >
    <div
      v-if="data"
      class="InboundLinks"
    >
      <div class="columns has-text-centered">
        <div class="column">
          <h6>{{ $t('seo_service.sub_headings.your_website') }}</h6>
          <arrow
            data-test="ownSite"
            :num="data.you"
            :display-figure="true"
            :font-size="fontSize"
          />
        </div>
        <div class="column">
          <h6>{{ $t('seo_service.sub_headings.avg_competitor') }}</h6>
          <arrow
            data-test="competitorSite"
            :num="data.competitor_avg"
            :display-figure="true"
            :font-size="fontSize"
          />
        </div>
      </div>
    </div>
    <data-placeholder v-else />
  </div>
</template>

<script>
import TrendArrow from '@/components/Shared/TrendArrow'
import Placeholder from '@/components/Shared/DataPlaceholder'

export default {
  name: 'BaseInboundLinks',
  components: {
    arrow: TrendArrow,
    dataPlaceholder: Placeholder
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        you: 0,
        competitor_avg: 0
      })
    },
    loading: {
      type: Boolean,
      default: false
    },
    supportsBlur: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fontSize: '2em',
      inboundLinks: null
    }
  }
}
</script>
<style lang="css" scoped>

</style>
